<aside id="app-sidebar-drawer" class="sidebar" [class.is-collapsed]="shouldCollapseRail()" [class.is-open]="drawerOpen()" [class.sidebar--drawer-only]="drawerOnly">
    <nav class="nav" aria-label="App navigation">
        <div class="nav-section nav-section--top" *ngIf="isLink(nav[0])">
            <ul>
                <li>
                    <a class="nav-link" [routerLink]="$any(nav[0]).to" [queryParams]="$any(nav[0]).query || null"
                        [class.is-active]="isLinkActive($any(nav[0]))" (click)="closeDrawer()"
                        aria-label="Home base" pTooltip="Home base" tooltipPosition="right"
                        [tooltipDisabled]="!shouldCollapseRail()">
                        <i class="pi nav-ic pi-compass" aria-hidden="true"></i>
                        <span class="label">Home base</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="nav-section">
            <p class="section-heading">Practice</p>
            <ng-container *ngIf="isGroup(nav[1])">
                <div class="nav-group nav-block">
                    <button class="group-header" type="button" (click)="toggleGroup(1)"
                        aria-label="Practice Library" pTooltip="Practice Library" tooltipPosition="right"
                        [tooltipDisabled]="!shouldCollapseRail()"
                        [attr.aria-expanded]="isGroupExpanded(1)" [attr.aria-controls]="'group-1'">
                        <i class="pi nav-ic pi-box" aria-hidden="true"></i>
                        <span class="label">Practice Library</span>
                        <i class="pi caret" aria-hidden="true" [ngClass]="$any(nav[1]).open ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>

                    <div class="group-list" [id]="'group-1'" [class.open]="$any(nav[1]).open"
                        [attr.aria-hidden]="isGroupContentHidden(1) ? 'true' : null"
                        [attr.inert]="isGroupContentHidden(1) ? '' : null">
                        <ul class="group-inner">
                            <li *ngFor="let c of $any(nav[1]).children">
                                <a class="nav-sublink" [routerLink]="c.to" [queryParams]="c.query || null"
                                    [class.is-active]="isLinkActive(c)" [attr.aria-label]="c.label" (click)="closeDrawer()">
                                    <i class="pi nav-ic" [ngClass]="c.icon || 'pi pi-link'"></i>
                                    <span class="nav-sublink__content">
                                        <span class="label">{{ c.label }}</span>
                                        <span class="nav-badge" *ngIf="announcements.badgeFor(c.key) || c.badge as badge">{{ badge }}</span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="nav-section">
            <p class="section-heading">Plans</p>

            <ng-container *ngIf="isGroup(nav[2])">
                <div class="nav-group nav-block">
                    <button class="group-header" type="button" (click)="toggleGroup(2)"
                        aria-label="Study Plans" pTooltip="Study Plans" tooltipPosition="right"
                        [tooltipDisabled]="!shouldCollapseRail()"
                        [attr.aria-expanded]="isGroupExpanded(2)" [attr.aria-controls]="'group-2'">
                        <i class="pi nav-ic pi-directions-alt" aria-hidden="true"></i>
                        <span class="label">Study Plans</span>
                        <i class="pi caret" aria-hidden="true" [ngClass]="$any(nav[2]).open ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>

                    <div class="group-list" [id]="'group-2'" [class.open]="$any(nav[2]).open"
                        [attr.aria-hidden]="isGroupContentHidden(2) ? 'true' : null"
                        [attr.inert]="isGroupContentHidden(2) ? '' : null">
                        <ul class="group-inner">
                            <li *ngFor="let c of $any(nav[2]).children">
                                <a class="nav-sublink" [routerLink]="c.to" [queryParams]="c.query || null"
                                    [class.is-active]="isLinkActive(c)" [attr.aria-label]="c.label" (click)="closeDrawer()">
                                    <i class="pi nav-ic" [ngClass]="c.icon || 'pi pi-link'"></i>
                                    <span class="label">{{ c.label }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="isGroup(nav[3])">
                <div class="nav-group nav-block">
                    <button class="group-header" type="button" (click)="toggleGroup(3)"
                        aria-label="Reference guides" pTooltip="Reference guides" tooltipPosition="right"
                        [tooltipDisabled]="!shouldCollapseRail()"
                        [attr.aria-expanded]="isGroupExpanded(3)" [attr.aria-controls]="'group-3'">
                        <i class="pi nav-ic pi-bookmark" aria-hidden="true"></i>
                        <span class="label">Reference guides</span>
                        <i class="pi caret" aria-hidden="true" [ngClass]="$any(nav[3]).open ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>

                    <div class="group-list" [id]="'group-3'" [class.open]="$any(nav[3]).open"
                        [attr.aria-hidden]="isGroupContentHidden(3) ? 'true' : null"
                        [attr.inert]="isGroupContentHidden(3) ? '' : null">
                        <ul class="group-inner">
                            <li *ngFor="let c of $any(nav[3]).children">
                                <a class="nav-sublink" [routerLink]="c.to" [queryParams]="c.query || null"
                                    [class.is-active]="isLinkActive(c)" [attr.aria-label]="c.label" (click)="closeDrawer()">
                                    <i class="pi nav-ic" [ngClass]="c.icon || 'pi pi-link'"></i>
                                    <span class="label">{{ c.label }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="nav-section">
            <p class="section-heading">Productivity</p>
            <ng-container *ngIf="isGroup(nav[4])">
                <div class="nav-group nav-block">
                    <button class="group-header nav-link--pill" type="button" (click)="toggleGroup(4)"
                        aria-label="Shortcuts and tools" pTooltip="Shortcuts &amp; tools" tooltipPosition="right"
                        [tooltipDisabled]="!shouldCollapseRail()"
                        [attr.aria-expanded]="isGroupExpanded(4)" [attr.aria-controls]="'group-4'">
                        <i class="pi nav-ic pi-stopwatch" aria-hidden="true"></i>
                        <span class="label">Shortcuts &amp; tools</span>
                        <i class="pi caret" aria-hidden="true" [ngClass]="$any(nav[4]).open ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                    </button>

                    <div class="group-list" [id]="'group-4'" [class.open]="$any(nav[4]).open"
                        [attr.aria-hidden]="isGroupContentHidden(4) ? 'true' : null"
                        [attr.inert]="isGroupContentHidden(4) ? '' : null">
                        <ul class="group-inner">
                            <li *ngFor="let c of $any(nav[4]).children">
                                <a class="nav-sublink" [routerLink]="c.to" [queryParams]="c.query || null"
                                    [class.is-active]="isLinkActive(c)" [attr.aria-label]="c.label" (click)="closeDrawer()">
                                    <i class="pi nav-ic" [ngClass]="c.icon || 'pi pi-link'"></i>
                                    <span class="label">{{ c.label }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-container>
        </div>
    </nav>

    <!-- bottom tools -->
    <div class="tools">
        <div class="tools-left">
            <!-- Bug -->
            <button class="tool-icon-btn" type="button" pTooltip="Report a bug" tooltipPosition="right"
                (click)="openBugModal()" aria-label="Report a bug">
                <i class="fa-solid fa-bug" aria-hidden="true"></i>
            </button>

            <!-- Legal -->
            <button pButton type="button" icon="pi pi-shield" class="p-button-text p-button-icon-only legal-btn"
                [routerLink]="['/legal']" (click)="closeDrawer()" pTooltip="Legal" tooltipPosition="right" aria-label="Legal">
            </button>

            <!-- GitHub -->
            <a class="tool-icon-btn tool-icon-btn--link" [href]="githubRepoUrl" target="_blank" rel="noopener noreferrer"
                (click)="closeDrawer()" pTooltip="Star FrontendAtlas on GitHub" tooltipPosition="right"
                aria-label="Star FrontendAtlas on GitHub" data-testid="sidebar-github-link">
                <i class="pi pi-github" aria-hidden="true"></i>
            </a>
        </div>

        <div class="tools-right" *ngIf="!drawerOnly">
            <button pButton type="button" [icon]="collapsed ? 'pi pi-chevron-right' : 'pi pi-chevron-left'"
                class="p-button-rounded p-button-text p-button-icon-only" (click)="toggleCollapsed()"
                pTooltip="{{ collapsed ? 'Expand sidebar' : 'Collapse sidebar' }}" tooltipPosition="right"
                [attr.aria-label]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'">
            </button>
        </div>
    </div>

    <div
        class="mobile-auth-actions"
        [attr.aria-busy]="auth.authUiState() === 'pending' ? 'true' : null"
    >
        <div
            *ngIf="auth.authUiState() === 'pending'"
            class="mobile-auth-pending"
            data-testid="sidebar-mobile-auth-pending"
            aria-hidden="true"
        >
            <div class="mobile-auth-placeholder-row">
                <span class="mobile-auth-placeholder"></span>
                <span class="mobile-auth-placeholder"></span>
            </div>
            <span class="mobile-auth-placeholder mobile-auth-placeholder--wide"></span>
        </div>

        <ng-container *ngIf="auth.authUiState() === 'authenticated'">
            <a class="mobile-auth-btn mobile-auth-btn--profile" [routerLink]="['/profile']" (click)="closeDrawer()" data-testid="sidebar-mobile-profile">
                <i class="pi pi-user" aria-hidden="true"></i>
                <span>Profile</span>
            </a>
            <a *ngIf="!isPro()" class="mobile-auth-btn mobile-auth-btn--pricing" [routerLink]="['/pricing']" (click)="closeDrawer()" data-testid="sidebar-mobile-pricing">
                Upgrade
            </a>
        </ng-container>

        <ng-container *ngIf="auth.authUiState() === 'signed_out'">
            <div class="mobile-auth-row">
                <a class="mobile-auth-btn mobile-auth-btn--primary" [routerLink]="['/auth/signup']" (click)="closeDrawer()" data-testid="sidebar-mobile-signup">
                    Sign up
                </a>
                <a class="mobile-auth-btn" [routerLink]="['/auth/login']" (click)="closeDrawer()" data-testid="sidebar-mobile-login">
                    Log in
                </a>
            </div>
            <a class="mobile-auth-btn mobile-auth-btn--prep" [routerLink]="['/guides','interview-blueprint','intro']" (click)="closeDrawer()" data-testid="sidebar-mobile-start-prep">
                Start prep
            </a>
        </ng-container>
    </div>
</aside>

<div class="backdrop" *ngIf="drawerOpen()" (click)="closeDrawer()" aria-hidden="true"></div>
